import type { BattlefieldFieldKey } from '../generated/sim/runtime/battle-harness';
import { DailyField } from './daily-encounter';

export interface BattlefieldInfo {
  readonly name: string;
  readonly rule: string;
}

/** Keyed on the engine mirror's own union, so a field added or renamed in generated/sim
 *  fails the build here instead of leaving the arena labelled with a stale name. */
export const BATTLEFIELD_INFO: Record<BattlefieldFieldKey, BattlefieldInfo> = {
  FluxField: {
    name: 'Flux Field',
    rule: 'Randomize the stamina regen at the end of the round.',
  },
  ElementalField: {
    name: 'Elemental Field',
    rule: 'Randomly inflict a status condition on each mon at the end of the round.',
  },
  UnstableField: {
    name: 'Unstable Field',
    rule: 'Force each mon to swap out randomly at the end of the round.',
  },
};

/** The daily encounter names its field in lowercase; the engine mirror names the effect
 *  class. Lives here rather than beside the engine so the home views can read a field's
 *  name without pulling the local battle service (and the sim) into their chunk. */
const DAILY_FIELD_TO_KEY: Record<DailyField, BattlefieldFieldKey> = {
  flux: 'FluxField',
  elemental: 'ElementalField',
  unstable: 'UnstableField',
};

export function battlefieldFieldFromDailyField(
  field: DailyField | null | undefined,
): BattlefieldFieldKey | undefined {
  return field ? DAILY_FIELD_TO_KEY[field] : undefined;
}

export function battlefieldInfoForDailyField(field: DailyField): BattlefieldInfo {
  return BATTLEFIELD_INFO[DAILY_FIELD_TO_KEY[field]];
}
